import React from 'react';
import { TableRow, TableCell } from '../ui/table';

interface TableLoaderProps {
    rows?: number;
    columns: number;
}

const TableLoader: React.FC<TableLoaderProps> = ({ rows = 5, columns }) => {
    return (
        <>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <TableRow key={rowIndex} className="align-middle">
                    {Array.from({ length: columns }).map((_, colIndex) => (
                        <TableCell key={colIndex} className="p-3">
                            <div className="h-4 w-full bg-border animate-pulse rounded"></div>
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </>
    );
};

export default TableLoader;
